'use client';
import React from 'react';
import { useTheme } from '@emotion/react';
import { SidenavHeader } from './styles';
import { Drawer, Stack, StackProps } from '@mui/material';
import { smallDrawerWidth, bigDrawerWidth } from '../../../constants';

export type SidenavProps = {
    isPermanent: boolean;
    isOpen: boolean;
    toggleDrawer: (bool?: boolean) => void;
    children: React.ReactNode;
    additionalHeaderItems?: React.ReactNode;
    additionalHeaderProps?: StackProps;
};

const Sidenav: React.FC<SidenavProps> = ({
    isPermanent,
    isOpen,
    additionalHeaderItems,
    additionalHeaderProps,
    toggleDrawer,
    children
}) => {
    const { colors } = useTheme();
    const isDrawerOpen = isPermanent ? true : isOpen;

    return (
        <Drawer
            variant={'temporary'}
            hideBackdrop={!isOpen}
            anchor='left'
            open={isDrawerOpen}
            onClose={() => toggleDrawer(false)}
            sx={{
                width: isPermanent ? smallDrawerWidth : 0,
                height: '100%'
            }}
            PaperProps={{
                sx: {
                    backgroundColor: colors.primary15,
                    width: isOpen ? 'auto' : smallDrawerWidth,
                    minWidth: isOpen ? bigDrawerWidth : 0,
                    maxWidth: '90vw',
                    borderWidth: 0
                }
            }}
            elevation={2}
            // Setting disableEnforeFocus to true is necessary. Otherwise some TextFields may not be focusable (e.g. Search in Searchbar).
            // Found this fix here https://github.com/mui/material-ui/issues/24032#issuecomment-755873514
            ModalProps={{ disableScrollLock: !isOpen, disableEnforceFocus: true }}
        >
            <Stack
                sx={{
                    width: '100%',
                    height: '100%',
                    py: 1.5,
                    px: 1.5
                }}
            >
                {
                    <SidenavHeader {...additionalHeaderProps} direction={'row'}>
                        {additionalHeaderItems}
                    </SidenavHeader>
                }
                {children}
            </Stack>
        </Drawer>
    );
};

export { Sidenav };
